import { createApp } from 'vue'
import App from './App.vue'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import { pinia } from '@/config/pinia'
import router from './router'

import { PrimeVuePlugin } from './config/plugins/PrimeVue'
import 'primeflex/primeflex.css'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import './assets/theme.css'
import './index.css'

import localDateDirective from '@/shared/directives/localDate'
import basictDateDirective from './shared/directives/basictDate'
import Particles from '@tsparticles/vue3'
import { loadSlim } from '@tsparticles/slim'
import { configureSentry } from './config/sentry'

const app = createApp(App)
app.use(pinia)
pinia.use(piniaPluginPersistedState)
app.use(router)
app.use(PrimeVuePlugin)
app.use(ToastService)
app.use(ConfirmationService)
app.directive('local-date', localDateDirective)
app.directive('basic-date', basictDateDirective)
app.use(Particles, {
  async init(engine) {
    await loadSlim(engine) // Load the slim version of tsParticles
  },
})

configureSentry(app, router)

app.mount('#app')
